const trigger = ({ controller, props: { name, args = {} } }) => {
  // We have to use setTimeout to not trigger signal in signal
  if (name) {
    setTimeout(() => {
      controller.getSignal(name)(args)
    }, 0)
  }
}

export default [trigger]



// WEBPACK FOOTER //
// ./src/modules/App/chains/triggerSignal.js